import React from "react";
import { Form, Row, Col, Radio } from "antd";
import {
  DatePicker,
  Input,
  Select,
  RadioGroup,
  Typography,
  Button,
} from "../core";
import { editpaymentAct } from "../redux/Action/payment";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { MixStyle } from "../styles";
import moment from "moment";
const Notify_Utils = require("../helper/utils/Notification");
const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;
const EditPayment = ({
  form,
  paymentId: { id },
  onCancel,
  onCreate,
  ...rest
}) => {
  const { token } = useSelector((state) => state.auth);

  const paymentData = useSelector((state) => state.payments.payments).filter(
    (itmes) => {
      return itmes.payment_id === id;
    }
  )[0];
  const dispatch = useDispatch();
  let Error = useSelector((state) => state.errorReducer);
  const [updatedPayment, setupdatedPayment] = React.useState({});
  const unFormateDate = moment(paymentData?.date_dispatch);
  console.log(paymentData);
  const value = {
    ...paymentData,
    payment_date: unFormateDate,
  };
  const onValuesChange = (changedValues, valuse) => {
    console.log(valuse);
    setupdatedPayment((prev) => ({
      ...prev,
      contract_id: value.contract_id,
      contract_type: value.contract_type,
      buyer_id: value.buyer_id,
      company_id: value.company_id,
    }));

    if (changedValues.payment_date) {
      setupdatedPayment((prev) => ({
        ...prev,
        payment_date: changedValues.payment_date,
      }));
    } else if (changedValues.payment_amount) {
      setupdatedPayment((prev) => ({
        ...prev,
        payment_amount: changedValues.payment_amount,
      }));
    } else if (changedValues.payment_method) {
      setupdatedPayment((prev) => ({
        ...prev,
        payment_method: changedValues.payment_method,
      }));
    } else if (changedValues.description) {
      setupdatedPayment((prev) => ({
        ...prev,
        description: changedValues.description,
      }));
    } else if (changedValues.payment_option) {
      setupdatedPayment((prev) => ({
        ...prev,
        payment_option: changedValues.payment_option,
      }));
    } else {
      setupdatedPayment((prev) => ({
        ...prev,
      }));
    }
  };

  const onFinish = (fieldsValue) => {
    const length = Object.keys(updatedPayment).length;
    console.log(length);
    if (Object.keys(updatedPayment).length === 0) {
      onCancel();
    } else {
      console.log("updatedPayment", updatedPayment);
      dispatch(editpaymentAct(updatedPayment, id, token));
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      {Error.id === "EDIT_PAYMENT_FAIL" ? (
        Notify_Utils.openNotificationWithIcon(
          "error",
          "Error While Edit Payment"
        )
      ) : Error.id === "EDIT_PAYMENT_SUCC" ? (
        <>
          {Notify_Utils.openNotificationWithIcon("success", Error.msg)}
          {onCancel()}
        </>
      ) : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={value}
        onValuesChange={onValuesChange}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        {console.log("updatedPayment", updatedPayment)}
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Date"
              name="payment_date"
              rules={[
                {
                  required: true,
                  message: "Please Set Date!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Ammount"
              name="payment_amount"
              rules={[
                {
                  required: true,
                  message: "Please Enter Ammount!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Payment Method"
              name="payment_method"
              rules={[
                {
                  required: true,
                  message: "Please select Payment Method ",
                },
              ]}
            >
              <Select
                placeholder="Payment Method"
                Options={["check", "cash"]}
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: false,
                  message: "Please Enter Description!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              name="payment_option"
              label="Payment Status"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject("Please Select one"),
                },
              ]}
            >
              <RadioGroup placement="end-to-end" value={value.payment_option}>
                <Radio value="paid">Paid</Radio>
                <Radio value="receive">Receive</Radio>
              </RadioGroup>
            </Form.Item>
          </Col>
          {/* <Col md={12} sm={18} xs={24}></Col> */}
          <Col md={13} sm={18} xs={24}>
            <Row type="flex" justify="space-between">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Add"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
              <Col sm={10}>
                <Button bg="#404E67" type="primary" onClick={onCancel}>
                  <Typography
                    text="Cancel"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </>
  );
};

export default EditPayment;
